import { api } from '@/helpers/api'
import { commonUtils } from '@/helpers/commonUtils'
import { action, computed, makeObservable, observable } from 'mobx'
import { routerService } from '../routerService'

class UserService {
  @observable token: string = ''
  @observable userData: ServerData.UserData | null = null
  @observable menu: string = ''

  @computed get isLogin() {
    return !!this.token
  }

  constructor() {
    makeObservable(this)
  }

  public init() {
    const token = commonUtils.getCookie('token')
    this.token = token || ''
  }

  @action
  public async login(data: PostData.Login) {
    const res = await api.user.login(data)
    if (res.success) {
      this.token = res.data.token
      commonUtils.setCookie('token', this.token)
      return true
    }
    return false
  }

  @action
  public async logout() {
    this.token = ''
    commonUtils.deleteCookie('token')
    routerService.navigateTo('login')
  }

  @action
  public setMenu(path: string) {
    this.menu = path
  }
}

export const userService = new UserService()
